'use client';

import { forwardRef } from 'react';

import { Icon } from '../icon/icon';
import { iconButtonIconRecipe } from './styles/icon-button-icon.styles';
import type { IconButtonIconPropsInterface } from './types/icon-button-icon.types';

/**
 * @since 10.13.0
 */
export const IconButtonIcon = forwardRef<SVGSVGElement, IconButtonIconPropsInterface>(
  (props: IconButtonIconPropsInterface, forwardedRef) => {
    const { children, css: cssProp, loading = false, ...rest } = props;

    return (
      <Icon
        data-c11n-component="IconButton.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{
          ...iconButtonIconRecipe.raw({ loading }),
          ...cssProp,
        }}
        {...rest}
      >
        {children}
      </Icon>
    );
  },
);

IconButtonIcon.displayName = 'IconButton.Icon';
